/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiInstance } from '../../Apis/Axios';
import { ENDECRYPT_SERVICE } from '../EndPoints';

export const DecryptMessage = createAsyncThunk(
    'enDecryptService/decryptMessage',
    async (message) => {
        const result = await apiInstance
            .get(`${ENDECRYPT_SERVICE.decrypt}${encodeURIComponent(message)}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });

        const { data, status } = result;

        return { data, status };
    },
);
